import { render, staticRenderFns } from "./PoliticaComercial.vue?vue&type=template&id=37ac9df4"
import script from "./PoliticaComercial.vue?vue&type=script&lang=js"
export * from "./PoliticaComercial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports